import {Component, inject} from '@angular/core';
import {CurrencyPipe, DatePipe} from '@angular/common';
import {IconComponent} from '@kin/spark-ui';
import {AddressService} from '../property/address.service';
import {PropertyAssessmentService} from '../property/property-assessment.service';
import {CaseService} from '../case.service';
import {COUNTY_COPY, County, daysUntil, FILING_DEADLINE_DATE_FORMAT, getFilingDeadline, parseIsoDate} from '../county/county-config';

@Component({
  selector: 'app-property-sidebar',
  standalone: true,
  imports: [CurrencyPipe, DatePipe, IconComponent],
  templateUrl: './property-sidebar.component.html',
  styleUrl: './property-sidebar.component.css',
})
export class PropertySidebarComponent {
  protected addressService = inject(AddressService);
  protected assessment = inject(PropertyAssessmentService);
  private caseService = inject(CaseService);

  dateFormat = FILING_DEADLINE_DATE_FORMAT;

  private get county(): County {
    return this.assessment.data?.property?.countyCode ?? 'harris';
  }

  /** Real per-case value once a case exists; the county's fallback placeholder until then. */
  get filingDeadline(): Date {
    const real = this.caseService.caseData?.filingDeadline;
    return real ? parseIsoDate(real) : getFilingDeadline(this.county);
  }

  get daysLeft(): number {
    return daysUntil(this.filingDeadline);
  }

  get guarantees(): string[] {
    return [
      'Our fee is 10% of whatever you save — and only if we actually win a property tax assessment reduction.',
      "If we don't win, you owe nothing.",
      // Deliberately `noRiskCopy` (the "can only lower, never raise" claim), not
      // `guaranteeCopy` (fee-model prose that would just restate the two lines above).
      this.caseService.caseData?.complianceCopy?.noRiskCopy ?? COUNTY_COPY[this.county].guaranteeCopy,
    ];
  }
}
